<div class="container">
  <div class="faq-header d-flex justify-content-center">
    <h1>Domande frequenti per utenti PayER</h1>
  </div>

  <hr />

  <h5>Quali sono i costi delle commissioni sui pagamenti?</h5>
  <p>
    I costi di commissione pagoPA sono consultabili alla pagina
    <a href="https://www.pagopa.gov.it/it/cittadini/trasparenza-costi/"
      >trasparenza costi</a
    >
    di pagoPA. Se desideri pagare con il tuo conto corrente (home banking), i
    costi dipendono dal tipo di contratto in essere con la tua banca.
  </p>

  <h5>
    Quando effettuo un pagamento mi viene sempre proposto il costo di
    commissione più basso?
  </h5>
  <p>
    No, ti invitiamo a verificare sempre se è presente un gestore della
    transazione (PSP) che offre una commissione inferiore.
  </p>

  <h5>Come posso sapere se il pagamento è andato a buon fine?</h5>
  <p>
    Se hai pagato di persona allo sportello e hai la ricevuta, il pagamento è
    andato a buon fine. Se invece hai pagato online e hai inserito il tuo
    indirizzo e-mail, riceverai una mail di conferma da pagoPA. La mail potrebbe
    non arrivare subito: in caso di dubbio, aspetta qualche ora prima di
    ripetere il pagamento.
  </p>

  <h5>Posso usare la ricevuta di Lepida per fini fiscali?</h5>
  <p>
    No, la ricevuta di Lepida non ha valore fiscale. Ti serve solo come
    riepilogo del pagamento e può esserti utile per dimostrare all’Ente che hai
    pagato o per chiedere una verifica. La ricevuta valida ai fini fiscali deve
    essere rilasciata dall’Ente creditore.
  </p>

  <!-- <h5>
    Perchè nell’elenco degli Enti/servizi su
    <a href="https://payer.lepida.net/">PayER</a> non trovo quello di mio
    interesse?
  </h5>
  <p>
    E’ possibile che l’Ente o il servizio da te ricercato non sia intermediato
    da Lepida. Chiedi informazioni all’Ente o apri una segnalazione ad
    <a href="http://www.lepida.net/assistenza">assistenza Lepida</a>.
  </p> -->

  <h5>
    Perché nell’elenco degli Enti o servizi su PayER non trovo quello che mi
    interessa?
  </h5>
  <p>
    L’Ente o il servizio che stai cercando potrebbe non essere gestito da
    Lepida. In questo caso ti consigliamo di contattare direttamente l’Ente
    oppure di inviare una segnalazione all’
    <a href="http://www.lepida.net/assistenza">assistenza Lepida</a>.
  </p>

  <h5>Nella sezione ‘I miei pagamenti’ trovo tutti i miei pagamenti pagoPA?</h5>
  <p>
    No, in quella sezione trovi solo i pagamenti effettuati o da effettuare per
    i servizi gestiti da Lepida. Non sono visibili i pagamenti verso Enti non
    gestiti da Lepida.
  </p>

  <h5>Ho un avviso di pagamento cartaceo, posso pagarlo su PayER?</h5>
  <p>
    No, ma puoi pagare sul
    <a href="https://checkout.pagopa.it/">sito di pagoPA</a>.
  </p>
</div>
